webpackJsonp([31],{

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_vue__ = __webpack_require__(821);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c652248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_vue__ = __webpack_require__(998);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c652248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon() {
	this.$emit('click-icon');
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

function buttonColor() {
	return this.isEditAction ? '#3B82C4' : this.color;
}

function isEditAction() {
	return ['edit', 'create'].includes(this.icon);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		buttonColor: buttonColor,
		isEditAction: isEditAction,
		isListAll: isListAll
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'green'
		},
		icon: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01775c3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("673c19a2", content, true, {});

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.action-icon-button[data-v-01775c3c]{background:#f2f6f9!important;border:1px solid transparent;border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px}.action-icon-button .icon[data-v-01775c3c]{font-size:17px}.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef!important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa!important;border-color:#bed8ea}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-tooltip-button.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,qCAAqC,6BAA8B,6BAA+B,kBAAkB,YAAY,eAAe,2FAA2F,mFAAmF,2EAA2E,uGAAuG,UAAU,CACxf,AACD,2CAA2C,cAAc,CACxD,AACD,2CAA2C,6BAA8B,qBAAqB,mCAAmC,0BAA0B,CAC1J,AACD,0DAA0D,6BAA8B,oBAAoB,CAC3G","file":"app-tooltip-button.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.action-icon-button[data-v-01775c3c]{background:#f2f6f9 !important;border:1px solid rgba(0,0,0,0);border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px\n}\n.action-icon-button .icon[data-v-01775c3c]{font-size:17px\n}\n.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef !important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa !important;border-color:#bed8ea\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"action-icon-button ma-0",class:{ 'is-edit-action': _vm.isEditAction },attrs:{"slot":"activator","flat":"","icon":"","aria-label":_vm.text,"small":"","color":_vm.buttonColor,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon.apply(null, arguments)}},slot:"activator"},[_c('v-icon',{style:(_vm.isListAll)},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function actionToDo(item) {
	var action = item.link ? item.link : {
		width: item.width ? item.width : 0,
		title: item.text,
		code: item.code,
		active: item.active,
		open: true
	};
	var eventEmit = item.link ? 'to-link' : 'open-modal';
	this.$emit(eventEmit, action);
}

function setBorder(item) {
	var color = item.color === undefined ? '#9b9b9b' : item.color;
	return 'border-bottom: 4px solid ' + color;
}

function setMaxWidth(item) {
	var maxWidth = item.maxWidth ? item.maxWidth + 'px' : 'min-content';
	return 'max-width: ' + maxWidth;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'quick-actions',
	methods: {
		actionToDo: actionToDo,
		setBorder: setBorder,
		setMaxWidth: setMaxWidth
	},
	props: {
		actions: Array
	}
});

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_actions_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d5e0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_actions_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16d5e0be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_actions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d5e0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_actions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(592);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("2c1c9135", content, true, {});

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.actions[data-v-16d5e0be]{background:transparent;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0;position:fixed;right:48px;top:59px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;z-index:4}.actions .actions-bar[data-v-16d5e0be]{background:transparent;border:0;border-radius:7px;-webkit-box-shadow:none;box-shadow:none;padding:0}.actions .actions-bar .action-content[data-v-16d5e0be]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;height:36px}.actions .actions-bar .action-content .action[data-v-16d5e0be],.actions .actions-bar .action-content[data-v-16d5e0be]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.actions .actions-bar .action-content .action[data-v-16d5e0be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#1a4338;border:0!important;border-radius:7px;-webkit-box-shadow:0 2px 6px rgba(26,67,56,.25);box-shadow:0 2px 6px rgba(26,67,56,.25);color:#fff;cursor:pointer;height:32px;margin:0;opacity:.3;outline:none;padding:0 12px;text-align:center;-webkit-transition:background-color .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;transition:background-color .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;transition:background-color .2s ease,box-shadow .2s ease,transform .2s ease;transition:background-color .2s ease,box-shadow .2s ease,transform .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;width:auto}.actions .actions-bar .action-content .action .action-icon[data-v-16d5e0be]{color:#fff;font-size:21px}.actions .actions-bar .action-content .action .action-logo[data-v-16d5e0be]{height:21px;-o-object-fit:contain;object-fit:contain;width:21px}.actions .actions-bar .action-content .action .action-txt[data-v-16d5e0be]{font-family:Opens_regular;font-size:10px;color:#fff;font-size:13px;font-weight:600;margin:0 0 0 7px;max-width:none!important;text-align:left;white-space:nowrap}.actions .actions-bar .action-content .action[data-v-16d5e0be]:focus,.actions .actions-bar .action-content .action[data-v-16d5e0be]:hover{background:#12372e;-webkit-box-shadow:0 4px 10px rgba(26,67,56,.35);box-shadow:0 4px 10px rgba(26,67,56,.35);-webkit-transform:translateY(-2px);transform:translateY(-2px)}.actions .actions-bar .action-content .active[data-v-16d5e0be]{opacity:1}@media(max-width:900px){.actions .actions[data-v-16d5e0be]{margin:7px auto 10px;max-width:calc(100% - 24px);position:relative;right:auto;top:auto}.actions .actions .action-content[data-v-16d5e0be],.actions .actions .actions-bar[data-v-16d5e0be]{max-width:100%}.actions .actions .action-content[data-v-16d5e0be]{-ms-flex-wrap:wrap;flex-wrap:wrap;height:auto!important}}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/quick-actions.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,0BAA0B,uBAAyB,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,SAAS,eAAe,WAAW,SAAS,0BAA0B,uBAAuB,kBAAkB,SAAS,CACnS,AACD,uCAAuC,uBAAyB,SAAS,kBAAkB,wBAAwB,gBAAgB,SAAS,CAC3I,AACD,uDAAuD,sBAAsB,mBAAmB,qBAAqB,AAA2J,WAAW,CAC1R,AACD,sHAFqH,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,wBAAwB,qBAAqB,sBAAuB,CAG/Q,AADD,+DAA+D,yBAAyB,sBAAsB,mBAAmB,AAA2J,mBAAmB,mBAAoB,kBAAkB,gDAAgD,wCAAwC,WAAW,eAAe,YAAY,SAAS,WAAW,aAAa,eAAe,kBAAkB,oGAAoG,4FAA4F,4EAA4E,mIAAmI,UAAU,CAC76B,AACD,4EAA4E,WAAW,cAAc,CACpG,AACD,4EAA4E,YAAY,sBAAsB,mBAAmB,UAAU,CAC1I,AACD,2EAA2E,0BAA4B,eAAe,WAAW,eAAe,gBAAgB,iBAAiB,yBAA0B,gBAAgB,kBAAkB,CAC5O,AACD,0IAA0I,mBAAmB,iDAAiD,yCAAyC,mCAAmC,0BAA0B,CACnT,AACD,+DAA+D,SAAS,CACvE,AACD,wBACA,mCAAmC,qBAAqB,4BAA4B,kBAAkB,WAAW,QAAQ,CACxH,AACD,mGAAmG,cAAc,CAChH,AACD,mDAAmD,mBAAmB,eAAe,qBAAsB,CAC1G,CACA","file":"quick-actions.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.actions[data-v-16d5e0be]{background:rgba(0,0,0,0);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0;position:fixed;right:48px;top:59px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;z-index:4\n}\n.actions .actions-bar[data-v-16d5e0be]{background:rgba(0,0,0,0);border:0;border-radius:7px;-webkit-box-shadow:none;box-shadow:none;padding:0\n}\n.actions .actions-bar .action-content[data-v-16d5e0be]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:36px\n}\n.actions .actions-bar .action-content .action[data-v-16d5e0be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#1a4338;border:0 !important;border-radius:7px;-webkit-box-shadow:0 2px 6px rgba(26,67,56,.25);box-shadow:0 2px 6px rgba(26,67,56,.25);color:#fff;cursor:pointer;height:32px;margin:0;opacity:.3;outline:none;padding:0 12px;text-align:center;-webkit-transition:background-color .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;transition:background-color .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;transition:background-color .2s ease,box-shadow .2s ease,transform .2s ease;transition:background-color .2s ease,box-shadow .2s ease,transform .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;width:auto\n}\n.actions .actions-bar .action-content .action .action-icon[data-v-16d5e0be]{color:#fff;font-size:21px\n}\n.actions .actions-bar .action-content .action .action-logo[data-v-16d5e0be]{height:21px;-o-object-fit:contain;object-fit:contain;width:21px\n}\n.actions .actions-bar .action-content .action .action-txt[data-v-16d5e0be]{font-family:\"Opens_regular\";font-size:10px;color:#fff;font-size:13px;font-weight:600;margin:0 0 0 7px;max-width:none !important;text-align:left;white-space:nowrap\n}\n.actions .actions-bar .action-content .action[data-v-16d5e0be]:hover,.actions .actions-bar .action-content .action[data-v-16d5e0be]:focus{background:#12372e;-webkit-box-shadow:0 4px 10px rgba(26,67,56,.35);box-shadow:0 4px 10px rgba(26,67,56,.35);-webkit-transform:translateY(-2px);transform:translateY(-2px)\n}\n.actions .actions-bar .action-content .active[data-v-16d5e0be]{opacity:1\n}\n@media(max-width: 900px){\n.actions .actions[data-v-16d5e0be]{margin:7px auto 10px;max-width:calc(100% - 24px);position:relative;right:auto;top:auto\n}\n.actions .actions .actions-bar[data-v-16d5e0be],.actions .actions .action-content[data-v-16d5e0be]{max-width:100%\n}\n.actions .actions .action-content[data-v-16d5e0be]{-ms-flex-wrap:wrap;flex-wrap:wrap;height:auto !important\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"actions-bar"},[_c('div',{staticClass:"action-content"},_vm._l((_vm.actions),function(action,index){return _c('button',{key:index,staticClass:"action",class:{ active: action.active },style:(_vm.setBorder(action)),attrs:{"type":"button"},on:{"click":function($event){return _vm.actionToDo(action)}}},[(action.icon)?_c('v-icon',{staticClass:"action-icon",attrs:{"color":"white"}},[_vm._v(_vm._s(action.icon))]):(action.img)?_c('img',{staticClass:"action-logo",attrs:{"src":action.img,"alt":""}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"action-txt",style:(_vm.setMaxWidth(action))},[_vm._v(_vm._s(action.text))])],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_template_template_list__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_quick_actions__ = __webpack_require__(590);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	if (this.$route.name !== 'page-resources-assignment') {
		this.applyRouteSearch(this.$route);
		this.loadData('project/' + this.codeProject + '/template');
	}
}

function applyRouteSearch(route) {
	var search = route && route.query ? route.query.search : undefined;
	if (typeof search !== 'string') return;
	this.params.search = search.trim() || null;
	this.params.page = 1;
	this.currentPage = 1;
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData('project/' + this.codeProject + '/template');
}

function openModal() {
	this.goTo('page-template-clone', { params: { codeProject: this.codeProject, projectId: this.projectId } });
}

function data() {
	return {
		actions: [{
			id: 1,
			code: 'CC',
			text: 'Crear Template',
			icon: 'add_circle_outline',
			active: true
		}],
		columns: [{ id: 1, name: 'Nombre', checked: true, visible: true }, { id: 2, name: 'Descripcion', checked: true, visible: true }, { id: 3, name: 'Fecha de creación', checked: true, visible: true }, { id: 4, name: 'Acciones', checked: true, visible: true }],
		currentPage: 1
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-template',
	data: data,
	created: created,
	components: {
		templateList: __WEBPACK_IMPORTED_MODULE_0__components_template_template_list__["a" /* default */],
		quickActions: __WEBPACK_IMPORTED_MODULE_1__components_shared_quick_actions__["a" /* default */]
	},
	methods: {
		applyRouteSearch: applyRouteSearch,
		changePage: changePage,
		openModal: openModal
	},
	props: {
		codeProject: {
			type: String
		},
		projectId: {
			type: [Number, String]
		},
		codeTemplate: {
			type: [Number, String]
		}
	},
	watch: {
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-template') {
					this.applyRouteSearch(newVal);
					this.loadData('project/' + this.codeProject + '/template');
				}
			}
		}
	}
});

/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_helper__ = __webpack_require__(91);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var formatDate = __WEBPACK_IMPORTED_MODULE_1__shared_helper__["a" /* default */].formatDate,
    getLocalData = __WEBPACK_IMPORTED_MODULE_1__shared_helper__["a" /* default */].getLocalData,
    setLocalData = __WEBPACK_IMPORTED_MODULE_1__shared_helper__["a" /* default */].setLocalData;


function displayDate(value) {
	if (!value) return '—';
	var normalizedDate = typeof value === 'string' ? value.replace(' ', 'T') : value;
	return formatDate(normalizedDate, 'DD/MM/YYYY HH:mm');
}

function resource(_ref) {
	var codeTemplate = _ref.codeTemplate;

	this.goTo('page-distribution-of-resources', { params: { idDistribution: codeTemplate } });
}

function created() {
	this.idProject = this.projectId || getLocalData('project-id');
}

function detail(id) {
	this.goTo('page-template-detail', { params: { id: id, projectId: this.idProject } });
}

function newTemplate(_ref2) {
	var id = _ref2.id,
	    codeTemplate = _ref2.codeTemplate;

	setLocalData('code-template', codeTemplate);
	this.goTo('page-new-company', {
		params: { codeProject: this.codeProject },
		query: {
			templateId: id,
			codeTemplate: codeTemplate,
			returnTo: 'page-template'
		}
	});
}

function rolesDistribution(_ref3) {
	var id = _ref3.id,
	    codeTemplate = _ref3.codeTemplate;

	this.goTo('page-resources-assignment', {
		params: { idTemplate: id },
		query: { codeTemplate: codeTemplate }
	});
}

function editName(_ref4) {
	var codeTemplate = _ref4.codeTemplate,
	    id = _ref4.id;

	this.goTo('page-template-edit', { params: { id: id, codeTemplate: codeTemplate, projectId: this.idProject } });
}

function configurationProcess(_ref5) {
	var codeTemplate = _ref5.codeTemplate,
	    id = _ref5.id;

	this.goTo('page-configuration-process', { params: { codeTemplate: codeTemplate, id: id } });
}

function data() {
	return {
		idProject: 0
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'template-list',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__["a" /* default */]
	},
	created: created,
	data: data,
	props: {
		columns: {
			type: Array,
			required: true
		},
		currentPage: {
			type: Number,
			default: 1
		},
		lastPage: {
			type: Number,
			default: 0
		},
		rows: {
			type: Array,
			required: true
		},
		searchValue: {
			type: String,
			default: ''
		},
		codeProject: {
			type: String
		},
		projectId: {
			type: [Number, String]
		}
	},
	methods: {
		configurationProcess: configurationProcess,
		detail: detail,
		displayDate: displayDate,
		newTemplate: newTemplate,
		rolesDistribution: rolesDistribution,
		resource: resource,
		editName: editName
	}
});

/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_list_vue__ = __webpack_require__(822);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44bc0756_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_list_vue__ = __webpack_require__(997);
function injectStyle (ssrContext) {
  __webpack_require__(993)
  __webpack_require__(995)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44bc0756"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44bc0756_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(994);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("7d1c1437", content, true, {});

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.template-list-card[data-v-44bc0756]{background:#fff;border:1px solid #dfe6ee;border-radius:8px;-webkit-box-shadow:0 4px 14px rgba(31,56,82,.08);box-shadow:0 4px 14px rgba(31,56,82,.08);overflow:hidden}.template-list-toolbar[data-v-44bc0756]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f7f9fc;border-bottom:1px solid #e4eaf0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:66px;padding:10px 18px}.template-list-toolbar h3[data-v-44bc0756]{color:#34495e;margin:0 0 3px}.template-list-toolbar span[data-v-44bc0756]{color:#71808e;font-size:12px}.template-count[data-v-44bc0756]{background:#e6f2fd;border-radius:14px;color:#1a4338!important;font-weight:600;padding:5px 11px;white-space:nowrap}.template-actions[data-v-44bc0756]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;white-space:nowrap}.template-actions-cell[data-v-44bc0756]{min-width:0}.template-date-cell[data-v-44bc0756],.template-description-cell[data-v-44bc0756],.template-name-cell[data-v-44bc0756]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.template-date-cell[data-v-44bc0756]{text-align:center}@media(max-width:700px){.template-list-card[data-v-44bc0756]{margin-left:12px!important;margin-right:12px!important}.template-list-toolbar[data-v-44bc0756]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}", "", {"version":3,"sources":["/opt/build/repo/src/components/template/template-list.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,qCAAqC,gBAAgB,yBAAyB,kBAAkB,iDAAiD,yCAAyC,eAAe,CACxM,AACD,wCAAwC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,gCAAgC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,8BAA8B,gBAAgB,iBAAiB,CAC/T,AACD,2CAA2C,cAAc,cAAc,CACtE,AACD,6CAA6C,cAAc,cAAc,CACxE,AACD,iCAAiC,mBAAmB,mBAAmB,wBAAyB,gBAAgB,iBAAiB,kBAAkB,CAClJ,AACD,mCAAmC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,kBAAkB,CAC/O,AACD,wCAAwC,WAAW,CAClD,AACD,sHAAsH,gBAAgB,uBAAuB,kBAAkB,CAC9K,AACD,qCAAqC,iBAAiB,CACrD,AACD,wBACA,qCAAqC,2BAA4B,2BAA4B,CAC5F,AACD,wCAAwC,wBAAwB,qBAAqB,uBAAuB,4BAA4B,6BAA6B,0BAA0B,qBAAqB,CACnN,CACA","file":"template-list.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.template-list-card[data-v-44bc0756]{background:#fff;border:1px solid #dfe6ee;border-radius:8px;-webkit-box-shadow:0 4px 14px rgba(31,56,82,.08);box-shadow:0 4px 14px rgba(31,56,82,.08);overflow:hidden\n}\n.template-list-toolbar[data-v-44bc0756]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f7f9fc;border-bottom:1px solid #e4eaf0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:66px;padding:10px 18px\n}\n.template-list-toolbar h3[data-v-44bc0756]{color:#34495e;margin:0 0 3px\n}\n.template-list-toolbar span[data-v-44bc0756]{color:#71808e;font-size:12px\n}\n.template-count[data-v-44bc0756]{background:#e6f2fd;border-radius:14px;color:#1a4338 !important;font-weight:600;padding:5px 11px;white-space:nowrap\n}\n.template-actions[data-v-44bc0756]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;white-space:nowrap\n}\n.template-actions-cell[data-v-44bc0756]{min-width:0\n}\n.template-name-cell[data-v-44bc0756],.template-description-cell[data-v-44bc0756],.template-date-cell[data-v-44bc0756]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.template-date-cell[data-v-44bc0756]{text-align:center\n}\n@media(max-width: 700px){\n.template-list-card[data-v-44bc0756]{margin-left:12px !important;margin-right:12px !important\n}\n.template-list-toolbar[data-v-44bc0756]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(996);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("42574661", content, true, {});

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.template-table .table-list{table-layout:fixed}", "", {"version":3,"sources":["/opt/build/repo/src/components/template/template-list.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,4BAA4B,kBAAkB,CAC7C","file":"template-list.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.template-table .table-list{table-layout:fixed\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-list-card mx-5 mt-2"},[_c('app-table',{staticClass:"template-table",attrs:{"sticky-header":"","name":"templates","columns":_vm.columns,"column-widths":{ 1: '23%', 2: '30%', 3: '15%', 4: '32%' },"current-page":_vm.currentPage,"rows":_vm.rows,"last-page":_vm.lastPage,"search-value":_vm.searchValue},on:{"on-page":function($event){return _vm.$emit('on-page', $event)},"on-search-event":function($event){return _vm.$emit('on-search', $event)}},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{staticClass:"is-not-selectable template-name-cell",attrs:{"title":props.row.name}},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"template-description-cell",attrs:{"title":props.row.description}},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"template-date-cell"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.displayDate(props.row.createdAt))+"\n\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"template-actions-cell"},[_c('div',{staticClass:"template-actions"},[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"create","text":"Editar Nombre"},on:{"click-icon":function($event){return _vm.editName(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"green","icon":"visibility","text":"Detalle"},on:{"click-icon":function($event){return _vm.detail(props.row.id)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"primary","icon":"add_circle_outline","text":"Nueva Compañia"},on:{"click-icon":function($event){return _vm.newTemplate(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"infor","icon":"developer_board","text":"Distribución de roles"},on:{"click-icon":function($event){return _vm.rolesDistribution(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"info","icon":"cached","text":"Distrib. Recursos"},on:{"click-icon":function($event){return _vm.resource(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"red","icon":"highlight_off","text":"Eliminar"}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"primary","text":"Configurar Procesos","icon":"build"},on:{"click-icon":function($event){return _vm.configurationProcess(props.row)}}})],1)])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 998:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.showParentView('page-template'))?_c('div',[_c('header-page',{attrs:{"name":"template","title":_vm.$route.meta.title}}),_vm._v(" "),_c('template-list',{attrs:{"columns":_vm.columns,"current-page":_vm.currentPage,"rows":_vm.table.rows,"last-page":_vm.table.lastPage,"codeProject":_vm.codeProject,"project-id":_vm.projectId,"search-value":_vm.params.search || ''},on:{"on-page":_vm.changePage,"on-search":function($event){return _vm.onSearch($event, ("project/" + _vm.codeProject + "/template"))}}}),_vm._v(" "),_c('quick-actions',{attrs:{"actions":_vm.actions},on:{"open-modal":_vm.openModal}})],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/31.2373636fd8aca46ef4a4.js